import { useState } from 'react';
import DetailHeader from '../components/DetailHeader';
import DetailControls from '../components/DetailControls';
import WorkflowRunsBreakdownTile from '../components/tiles/WorkflowRunsBreakdownTile';
import WorkflowDurationsTile from '../components/tiles/WorkflowDurationsTile';
import WorkflowRunActionsPanel from '../components/WorkflowRunActionsPanel';
import type { Env } from '../types';

export default function EnvWorkflowsDetail({ env }: { env: Env }) {
  const [windowHours, setWindowHours] = useState(24);
  const [refreshToken, setRefreshToken] = useState(0);
  const bump = () => setRefreshToken((t) => t + 1);

  return (
    <div className="page">
      <DetailHeader
        env={env}
        title="Workflow runs"
        subtitle="Per-workflow volume, outcome and duration for the selected window. Failed runs can be resubmitted from the actions panel."
      />
      <DetailControls
        windowHours={windowHours}
        onWindowChange={setWindowHours}
        onRefresh={bump}
      />
      <section className="tile-grid tile-grid-wide">
        <WorkflowRunsBreakdownTile env={env} windowHours={windowHours} refreshToken={refreshToken} />
        <WorkflowDurationsTile env={env} windowHours={windowHours} refreshToken={refreshToken} />
        <WorkflowRunActionsPanel env={env} refreshToken={refreshToken} onResubmitted={bump} />
      </section>
    </div>
  );
}
